"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerComponents = exports.componentService = void 0;
var index_1 = require("../index");
var change_case_1 = require("change-case");
var Prop_1 = require("./decorators/Prop");
var Ref_1 = require("./decorators/Ref");
var Component_1 = require("./decorators/Component");
var storage_1 = require("./storage");
var components_1 = require("../utils/components");
var LegacySalvoLiteComponent_1 = require("./legacy/LegacySalvoLiteComponent");
function promiseWithCallbacks(executor) {
    var resolve = null;
    var reject = null;
    var p = new Promise(function (res, rej) {
        resolve = res;
        reject = rej;
        executor(res, rej);
    });
    if (!resolve || !reject) {
        throw new Error('promiseWithCallbacks did not init properly.');
    }
    return [p, resolve, reject];
}
var ComponentService = /** @class */ (function () {
    function ComponentService() {
        this.components = new storage_1.ComponentStorage();
        this.instances = new storage_1.InstanceStorage();
        this.legacySupport = false;
        this.bootstrapPromise = promiseWithCallbacks(function () { });
        this.readyPromise = promiseWithCallbacks(function () { });
    }
    ComponentService.prototype.bootstrapCompleted = function () {
        this.bootstrapPromise[1]();
    };
    Object.defineProperty(ComponentService.prototype, "bootstrapped", {
        get: function () {
            return this.bootstrapPromise[0];
        },
        enumerable: false,
        configurable: true
    });
    ComponentService.prototype.readyCompleted = function () {
        this.readyPromise[1]();
    };
    Object.defineProperty(ComponentService.prototype, "ready", {
        get: function () {
            return this.readyPromise[0];
        },
        enumerable: false,
        configurable: true
    });
    ComponentService.prototype.register = function (componentDef) {
        index_1.log.internal(this.constructor.name, "Register ".concat(componentDef.name, " (").concat(componentDef.variant || 'base variant', ")"), {
            componentDef: componentDef,
        });
        this.components.push(componentDef);
    };
    ComponentService.prototype.enableLegacySupport = function () {
        this.legacySupport = true;
    };
    ComponentService.prototype.bootstrap = function () {
        var e_1, _a, e_2, _b;
        var _this = this;
        index_1.log.internal(this.constructor.name, "Bootstrapping.");
        try {
            for (var _c = __values(this.components.all()), _d = _c.next(); !_d.done; _d = _c.next()) {
                var def = _d.value;
                index_1.log.internal(this.constructor.name, "Bootstrapping ".concat(def.name));
                var selector = def.meta.selector || (0, change_case_1.paramCase)(def.name);
                if (def.meta.isLegacy) {
                    if (!this.legacySupport) {
                        throw new Error("Legacy component ".concat(def.name, " found, but legacy component")
                            + "support is not enabled. Pass enableLegacySalvoLiteComponentSupport to main().");
                    }
                    var els = Array.from(document.querySelectorAll(def.meta.selector));
                    try {
                        for (var els_1 = (e_2 = void 0, __values(els)), els_1_1 = els_1.next(); !els_1_1.done; els_1_1 = els_1.next()) {
                            var el = els_1_1.value;
                            var instance = new def.component();
                            this.instances.push(instance);
                            Promise.resolve(instance.init(el)).catch(function (e) {
                                index_1.log.error(_this.constructor.name, "Error in component init", { e: e });
                            });
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (els_1_1 && !els_1_1.done && (_b = els_1.return)) _b.call(els_1);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                }
                else {
                    window.customElements.define(selector, def.component);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
        index_1.log.internal(this.constructor.name, "Bootstrapping done.");
        this.bootstrapCompleted();
        this.readyCompleted();
    };
    ComponentService.prototype.instanceConnected = function (instance) {
        this.instances.push(instance);
    };
    ComponentService.prototype.instanceDisconnected = function (instance) {
        this.instances.remove(instance);
    };
    return ComponentService;
}());
exports.componentService = new ComponentService;
function registerComponent(key, mod, variant) {
    var name = (0, components_1.normalizeComponentName)(key);
    var pascalName = (0, change_case_1.pascalCase)(name);
    if (name != pascalName) {
        throw new Error("File './components/".concat(key, "' should use filename ").concat(pascalName, ".ts (for element name ").concat(name, ")"));
    }
    var component = mod[name];
    if (!component) {
        throw new Error("File './components/".concat(key, "' must export a class named ")
            + "'".concat(name, "' for component auto-registration."));
    }
    var meta = (0, Component_1.extractComponentDefinition)(component);
    if (!meta) {
        throw new Error("Component ".concat(name, " must use the @Component() decorator."));
    }
    var props = (0, Prop_1.extractPropDefinitions)(component);
    var refs = (0, Ref_1.extractRefDefinitions)(component);
    exports.componentService.register({
        name: name,
        component: component,
        meta: meta,
        props: props,
        refs: refs,
        variant: variant,
    });
}
// This function gets passed a require context, which is a kind of obscure Webpack
// interface for dynamically (but not actually) importing modules from within a given folder.
// Impossible to type due to the dynamic nature, thus the use of any.
// See https://webpack.js.org/guides/dependency-management/#requirecontext
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function registerComponents(requireContext, buildVariant) {
    var keys = Array.from(requireContext.keys());
    var filteredKeys = keys.map(function (key) {
        var filenameRegex = /^([^~\n]+)(?:~([^\n~]+))?\.([^\n~]+?)$/;
        var _a = __read(Array.from(filenameRegex.exec(key) || []), 4), filename = _a[0], assetName = _a[1], variantName = _a[2], assetExtension = _a[3];
        var nonVariantFilename = "".concat(assetName, ".").concat(assetExtension);
        if (!buildVariant) {
            if (variantName) {
                return null;
            }
            return [key, nonVariantFilename, variantName];
        }
        if (variantName) {
            if (variantName != buildVariant) {
                return null;
            }
            return [key, nonVariantFilename, variantName];
        }
        // build variant set, this is a non-variant file
        var variantFilename = "".concat(assetName, "~").concat(buildVariant, ".").concat(assetExtension);
        if (keys.indexOf(variantFilename) > -1) {
            return null;
        }
        return [key, nonVariantFilename, variantName];
    }).filter(function (f) { return f != null; });
    filteredKeys.map(function (_a) {
        var _b = __read(_a, 3), key = _b[0], nonVariantFilename = _b[1], variantName = _b[2];
        var filename = key.split('/').pop();
        var content = requireContext(key);
        var filenameRegex = /^([^~\n]+)(?:~([^\n~]+))?\.([^\n~]+?)$/;
        var _c = __read(Array.from(filenameRegex.exec(filename) || []), 4), fn = _c[0], assetName = _c[1], vn = _c[2], assetExtension = _c[3];
        if (variantName) {
            filename = "".concat(assetName, ".").concat(assetExtension);
        }
        if (!filename || filename.indexOf('.') === -1) {
            // requireContext.keys() contains filenames both with and without extensions
            return;
        }
        if (filename) {
            if (filename.match(/\.stories\.ts$/)) {
                // handle stories
                return;
            }
            if (filename.match(/\.tsx?$/)) {
                registerComponent(filename, content, variantName);
                return;
            }
            if (filename.match(/\.scss$/)) {
                // handle scss
                index_1.log.debug('componentService', 'scss', { filename: filename, content: content });
                return;
            }
            if (filename.match(/\.liquid$/)) {
                // handle template
                return;
            }
            if (filename.match(/\.js$/)) {
                if (!content.default || content.default != LegacySalvoLiteComponent_1.LEGACY_COMPONENT_REGISTRATION) {
                    throw new Error("".concat(key, " is invalid - the only .js files allowed in components/ are legacy")
                        + " components, which must export default registerLegacySalvoLiteComponent(...).");
                }
                return;
            }
        }
        throw new Error("Unrecognized filename format in components directory ".concat(filename));
    });
}
exports.registerComponents = registerComponents;
//# sourceMappingURL=componentService.js.map